import blank from './blank/blank.vue';
import category from './category/category.vue';
import column from './column/column.vue';
import footer from './footer/footer.vue';
import goods from './goods/goods.vue';
import line from './line/line.vue';
import navigation from './navigation/navigation.vue';
import search from './search/search.vue';
import text from './text/text.vue';
import title from './title/title.vue';
import top from './top/top.vue';

export default {
    blank,
    category,
    column,
    footer,
    goods,
    line,
    navigation,
    search,
    text,
    title,
    top
};